import { TokensMath } from '../../../Fct/plugins/tokensMath';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiSubtract = createMulticallPlugin({
    plugin: TokensMath.getters.Subtract,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiCall',
    name: 'multiSubtract',
    config: {
        params: [
            { key: 'methodParams.amount1', multicallKey: 'amount1', isPreview: true },
            { key: 'methodParams.decimals1', multicallKey: 'decimals1' },
            { key: 'methodParams.amount2', multicallKey: 'amount2', isPreview: true },
            { key: 'methodParams.decimals2', multicallKey: 'decimals2' },
            { key: 'methodParams.decimalsOut', multicallKey: 'decimalsOut' },
        ],
        tupleName: 'subtrahends',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
